import { c as _c } from "react/compiler-runtime";
import React, { type JSX } from 'react';
import { DigitalResourcesTypeEnum } from 'modules/digital-product/enums/digital-resources-type-enum';
import { DigitalResourcesDataInterface, useDigitalResources } from '../hooks/use-digital-resources';
import { DigitalResourceEditType } from '../types/digital-resource-edit-interface';
import { BinIcon } from '@systemeio/ui/icons';
interface DigitalResourceWrapperProps {
  resource: DigitalResourceEditType;
  children: (data: DigitalResourcesDataInterface) => JSX.Element;
  onDelete?: () => void;
}
const DigitalResourceWrapper = t0 => {
  const $ = _c(14);
  const {
    resource,
    children,
    onDelete
  } = t0;
  const courseId = resource.type === DigitalResourcesTypeEnum.membership_course ? resource.course : undefined;
  const courseBundleId = resource.type === DigitalResourcesTypeEnum.membership_course_bundle ? resource.courseBundle : undefined;
  let t1;
  if ($[0] !== courseBundleId || $[1] !== courseId || $[2] !== resource.type) {
    t1 = {
      resourceType: resource.type,
      courseId,
      courseBundleId
    };
    $[0] = courseBundleId;
    $[1] = courseId;
    $[2] = resource.type;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const data = useDigitalResources(t1);
  let t2;
  if ($[4] !== children || $[5] !== data) {
    t2 = children(data);
    $[4] = children;
    $[5] = data;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <div className="flex flex-1 flex-col gap-3">{t2}</div>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== onDelete) {
    t4 = onDelete && <button onClick={onDelete} className="group h-fit outline-hidden"><BinIcon className="h-[18px] w-[17px] cursor-pointer" /></button>;
    $[9] = onDelete;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <><div className="border-text-secondary/30 flex gap-3 rounded-lg border p-2 ">{t3}{t4}</div></>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
export default DigitalResourceWrapper;